import React from 'react';
import PropTypes from 'prop-types';

const Loader = props => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <svg width={props.size} height={props.size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className="lds-eclipse" style={{ animationPlayState: 'running', animationDelay: '0s', background: 'none' }}>
      <path ng-attr-d="{{config.pathCmd}}" ng-attr-fill="{{config.color}}" stroke="none" d="M20 50A30 30 0 0 0 80 50A30 32 0 0 1 20 50" fill="#fdfdfd" transform="rotate(36 50 51)" style={{ animationPlayState: 'running', animationDelay: '0s' }}>
        <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 51;360 50 51" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" style={{ animationPlayState: 'running', animationDelay: '0s' }} />
      </path>
    </svg>
  </div>
);

Loader.defaultProps = {
  size: '100px',
};

Loader.propTypes = {
  size: PropTypes.string,
};

export default Loader;
